module.exports = __webpack_public_path__ + "static/media/arcada_logo_black.cdd0959a.webp";